(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/race-handler/common/constants.js') >= 0) return;  svs.modules.push('/components/sport/race-handler/common/constants.js');
'use strict';

const LOGGER_NAME = 'sport:race-handler';
const RACE_CACHE_TIME = 60 * 1000;
const toExport = {
  LOGGER_NAME,
  RACE_CACHE_TIME
};
setGlobal('svs.components.sport.raceHandler.common.constants', toExport);

 })(window);